import { render, staticRenderFns } from "./CreateProgressoInteligente.vue?vue&type=template&id=5442906c&"
import script from "./CreateProgressoInteligente.vue?vue&type=script&lang=js&"
export * from "./CreateProgressoInteligente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports